<template>
    <v-navigation-drawer
        v-model="drawer"          
        width="450"
        app
        temporary
        right
        class="wost-drawer"
    >
        <div class="form-head">
            {{ titleForm }}
        </div>

        <div class="pl-3 pt-3 pr-3">
            <v-card>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                    ref="name"
                                    v-model="form.name"
                                    label="Nombre de color"
                                    outlined
                                    dense
                                    :rules="[() => !!form.name || 'Es necesario ingresar un nombre']"
                                    hide-details="auto"
                                    required
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-card>
        </div>

        <div class="pl-3 pt-3 pr-3">
            <template>
                <v-row>
                    <v-col cols="6">
                        <v-btn @click="handleCancel" 
                            block 
                            dark
                            color="red">
                            Cancelar
                        </v-btn>
                    </v-col>
                    <v-col cols="6">
                        <v-btn v-if="action == 'create'"
                            dark 
                            color="green" 
                            block
                            @click="handleCreate">
                            Guardar
                        </v-btn>
                        <v-btn v-else
                            dark 
                            color="blue" 
                            block
                            @click="handleUpdate">
                            Actualizar
                        </v-btn>
                    </v-col>
                </v-row>
            </template>
        </div>
    </v-navigation-drawer>
</template>

<script>
import {mapActions, mapState} from 'vuex';

export default {
    name: 'CreateUpdate',
    data () {
        return {
            titleForm: '',
            drawer: false,
            action: '',
            form: {
                id: null,
                name: null
            }
        }
    },
    computed: {
        ...mapState('colors', [
            'color_response'
        ])
    },
    methods: {
        ...mapActions('colors', [
            'store',
            'update'
        ]),
        async show(title, action, color = null) {
            await this.clearErrors();
            this.titleForm = title;
            this.action = action;
            if (color) {
                this.setColor(color);
            }
            this.drawer = !this.drawer;
        },
        clearForm () {
            this.form.id = null;
            this.form.name = null;
            this.clearErrors();
        },
        closeForm () {
            this.clearForm();
            this.drawer = false;
        },
        setColor (color) {
            this.form.id = color.id;
            this.form.name = color.name;
        },
        handleCancel () {
            this.closeForm();
        },
        async handleCreate () {
            if (!this.existErrors()) {
                await this.store(this.form);
                if (this.color_response == 'error') {
                    this.$notify({
                        group: 'foo',
                        type: 'error',
                        title: 'REGISTRO DE COLOR',
                        text: 'Ocurrió un error al registrar color.'
                    });
                } else {
                    this.closeForm();
                    this.$notify({
                        group: 'foo',
                        type: 'success',
                        title: 'REGISTRO DE COLOR',
                        text: 'Color registrado de forma correcta.'
                    });                    
                }
            }
        },
        async handleUpdate () {
            if (!this.existErrors()) {
                await this.update(this.form);
                if (this.color_response == 'error') {
                    this.$notify({
                        group: 'foo',
                        type: 'error',
                        title: 'ACTUALIZACION DE COLOR',
                        text: 'Ocurrió un error al actualizar color.'
                    });
                } else {
                    this.closeForm();
                    this.$notify({
                        group: 'foo',
                        type: 'success',
                        title: 'ACTUALIZACION DE COLOR',
                        text: 'Color actualizado de forma correcta.'
                    });
                }
            }
        },
        existErrors(){
            let hasErrors = false;

            Object.keys(this.form).forEach(f => {                
                if (this.$refs[f]) {
                    if (!this.form[f]) hasErrors = true
                    this.$refs[f].validate(true);
                }                
            });

            return hasErrors;
        },
        clearErrors() {
            Object.keys(this.form).forEach(f => {
                if (this.$refs[f]) this.$refs[f].reset()                
            });
        }
    }
}
</script>

<style scoped>

</style>